import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SaveIcon from '@mui/icons-material/Save';
import { parseAndFormatDate } from '../../util/DateUtil';
import useMessage from '../../util/useMessage';
import { Controller, useForm } from 'react-hook-form';
import SubmitButton from '../../ui/SubmitButton';
import Input from '../../ui/Input';
import DateInput from '../../ui/DateInput';
import BatchStatusEnum from '../../enum/BatchStatusEnum';
import EnumSelect from '../../ui/EnumSelect';
import InputText from '../../ui/InputText';
import SysGlobalKeyservice from '../../service/MasterServices/SysGlobalKeyService';
import SysGlobalGroupservice from '../../service/MasterServices/SysGlobalGroupService';
import ComplexAutocomplete from '../../ui/ComplexAutocomplete';
import { Add } from '@mui/icons-material';
import CustButton from '../../ui/CustButton';
import ComplexSelect from '../../ui/ComplexSelect ';
import useGlobal from '../../util/Global';

const SysGlobalKeyCrudDialog = ({ open, onClose, data, crudTip, title }) => {

    const { g } = useGlobal();
    const showMessage = useMessage();
    const [crudtitle, SetCrudtitle] = useState("");
    const [isGroupIns, setIsGroupIns] = useState(false);
    const [SysGlobalGroupIdList, setSysGlobalGroupIdList] = useState([]);


    const inputObject = {
        id: data?.id,
        keyLabel: data?.keyLabel,
        groupKey: data?.groupKey,
        sira: data?.sira,
        tRKeyValue: data?.trKeyValue,
        eNKeyValue: data?.enKeyValue,
    };

    const { handleSubmit, register, control, reset, formState: { errors }, setValue } = useForm({
        defaultValues: {
            ...inputObject
        }
    });

    const getData = () => {
        SysGlobalGroupservice.get().then((response) => {
            if (response && response.isSuccess) {
                setSysGlobalGroupIdList(response.resultObject);

            }
        }).catch((error) => {
            console.error("Failed to fetch data:", error);
        });

    }

    useEffect(() => {

        if (SysGlobalGroupIdList.length > 0 && data?.sysGlobalGroupId) {
            setValue("sysGlobalGroupId", SysGlobalGroupIdList.find(r => r.id === data?.sysGlobalGroupId));
        }
    }, [setValue, SysGlobalGroupIdList, data])


    useEffect(() => {
        if (open) {
            reset({
                ...inputObject
            });
            setIsGroupIns(false);
            setLoading(false);
            setStatusUpdated(false);
            getData();
            if (crudTip === "Create") {
                SetCrudtitle((title) + " " + g("button.add"));

            } else {
                SetCrudtitle((title) + " " + g("button.update"));
            }
        }
    }, [open, reset]);

    const [loading, setLoading] = useState(false);
    const [statusUpdated, setStatusUpdated] = useState(false);

    const Create = async (input) => {
        const { resultObject } = await SysGlobalKeyservice.register({
            keyLabel: input?.keyLabel,
            sysGlobalGroupId: input?.sysGlobalGroupId.id,
            groupKey: input?.groupKey,
            sira: input?.sira,
            tRKeyValue: input?.tRKeyValue,
            eNKeyValue: input?.eNKeyValue,
        });
        return resultObject;
    };

    const Update = async (input) => {
        const { resultObject } = await SysGlobalKeyservice.fullupdate({
            id: data?.id,
            keyLabel: input?.keyLabel,
            sysGlobalGroupId: input?.sysGlobalGroupId.id,
            groupKey: input?.groupKey,
            sira: input?.sira,
            tRKeyValue: input?.tRKeyValue,
            eNKeyValue: input?.eNKeyValue,
        });
        return resultObject;
    };

    const onSubmit = async (input) => {
        if (loading) return false;
        try {
            setLoading(true);
            let status = false;
            if (crudTip === "Create") {
                status = await Create(input);
            } else {
                status = await Update(input);
            }
            setLoading(false);
            if (status) {
                setStatusUpdated(true);
                showMessage(g('message.created'));
            } else {
                showMessage(g('message.updateFailed'));
            }
            return status;
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    const InsertForm = () => {
        return (
            <Grid container spacing={1} alignItems="center">
                {isGroupIns == false ?
                    <>
                        <Grid item xs={9}>
                            <ComplexAutocomplete
                                name="sysGlobalGroupId"
                                label={g("col.groupKey")}
                                data={SysGlobalGroupIdList}
                                control={control}
                                error={errors.sysGlobalGroupId}
                                valueKey="id"
                                displayKey={["sira", "groupKey"]}
                                rules={{ required: g('validation.required') }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <CustButton
                                icon={Add}
                                onClick={() => { setIsGroupIns(true); setValue('sysGlobalGroupId', null); }}
                            >
                                {g("button.add")}
                            </CustButton>

                        </Grid>
                    </>
                    :
                    <InputText
                        name="groupKey"
                        label={g('col.groupKey')}
                        control={control}
                        rules={{ required: g('validation.required') }}
                    />
                }

                <InputText
                    name="keyLabel"
                    label={g('col.keyLabel')}
                    control={control}
                    rules={{ required: g('validation.required') }}
                />

                <InputText
                    name="tRKeyValue"
                    label={g('col.trKeyValue')}
                    control={control}
                    rules={{ required: g('validation.required') }}
                />

                <InputText
                    name="eNKeyValue"
                    label={g('col.enKeyValue')}
                    control={control}
                />
            </Grid>
        );
    };

    const UpdateForm = () => {
        return (
            <Grid container spacing={1} alignItems="center">
                {isGroupIns == false ?
                    <>
                        <Grid item xs={9}>
                            <ComplexAutocomplete
                                name="sysGlobalGroupId"
                                label={g("col.groupKey")}
                                data={SysGlobalGroupIdList}
                                control={control}
                                error={errors.sysGlobalGroupId}
                                valueKey="id"
                                displayKey={["sira", "groupKey"]}
                                rules={{ required: g('validation.required') }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <CustButton
                                icon={Add}
                                onClick={() => { setIsGroupIns(true); setValue('sysGlobalGroupId', null); }}
                            >
                                {g("button.add")}
                            </CustButton>

                        </Grid>
                    </>
                    :
                    <InputText
                        name="groupKey"
                        label={g('col.groupKey')}
                        control={control}
                        rules={{ required: g('validation.required') }}
                    />
                }

                <InputText
                    name="keyLabel"
                    label={g('col.keyLabel')}
                    control={control}
                    rules={{ required: g('validation.required') }}
                />

                <InputText
                    name="tRKeyValue"
                    label={g('col.trKeyValue')}
                    control={control}
                    rules={{ required: g('validation.required') }}
                />

                <InputText
                    name="eNKeyValue"
                    label={g('col.enKeyValue')}
                    control={control}
                />
            </Grid>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xl"
            scroll="paper"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{crudtitle}</DialogTitle>
                <DialogContent dividers style={{ display: 'flex', gap: '16px' }}>
                    {data ? UpdateForm() : InsertForm()}
                </DialogContent>
                <DialogActions>
                    {statusUpdated ? (
                        <Button onClick={onClose} color="primary">
                            {g('button.done')}
                        </Button>
                    ) : (
                        <>
                            <Button onClick={onClose} color="primary" disabled={loading}>
                                {g('button.cancel')}
                            </Button>
                            <SubmitButton loading={loading} startIcon={<SaveIcon />}>
                                {g('button.save')}
                            </SubmitButton>
                        </>
                    )}
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default React.memo(SysGlobalKeyCrudDialog);